import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AbstractStudentAddComponent, mapStateToProps } from './abstract'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Sidebar } from '~/components/sidebar'
import { Header } from '~/components/header'
import { Table } from '~/components/table'
import * as route from '~/helper/constant/route'
import { Button, Input, TextArea } from '~/components/form'
import MultiImageInput from 'react-multiple-image-input'
import { Loading } from '~/components/loader'
import Select from 'react-select'
import Files from 'react-files'
import DatePicker from 'react-datepicker'
import $ from 'jquery'
import { withTranslation } from 'react-i18next'
import moment from 'moment'
import { convertADtoBS } from '../../../../../helper/function'

class StudentAddComponent extends AbstractStudentAddComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
        this.setDate = this.setDate.bind(this)
        this.setJoinDate = this.setJoinDate.bind(this)
        this.setStudentCategory = this.setStudentCategory.bind(this)
    }

    setStudentCategory(data) {
        super._handleChange('selectedStudentCategory', data.value)
    }

    setDate(data) {
        super._handleChange('dob', data)
    }

    setJoinDate(data) {
        super._handleChange('joining_date', data)
    }

  



    render() {
        const { t } = this.props
        return (
            <div className="main-page">
                <Loading status={this.state.loading} text={this.state.loadingText} />
                <Sidebar id="user" />
                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>
                                <a href={route.admin.user.menu}>{t('users:breadcrumb')} > </a>
                            </li>
                            <li>
                                <a href={route.admin.user.student.menu}>{t('student:student.title')} > </a>
                            </li>
                            <li>
                                <a href={route.admin.user.student.view + '/' + this.state.section_id}>{t('student:student.breadcrumb')} > </a>
                            </li>
                            <li>{t('student:student.add.breadcrumb')}</li>
                        </ul>
                        <div className="row clearfix">
                            <div className="col-md-12 float-left">
                                <span className="sub-main-title">{this.state.section && this.state.section.classes.name + ' - ' + this.state.section.name}</span>
                                <h5 className="main-title heading5">{t('student:student.add.title')}:</h5>
                            </div>
                        </div>
                    </div>
                    <div className="main-form">
                        <div className="row clearfix">
                            <div className="col-sm-6 float-left form-group find-user">
                                <label className="form-title">{t('student:student.add.searchByRegCodeLabel')}</label>
                                <div className="user-load">
                                    <Input name="student_regcode" onChange={this._handleChange} placeholder={t('student:student.add.searchByRegCodePlaceholder')} type="text" value={this.state.student_regcode} readOnly={this.state.found_student && 'true'} />
                                    {!this.state.found_student && (
                                        <span onClick={this.findUserByRegCode.bind(this, 'student')}>
                                            <FontAwesomeIcon className="icon" icon="search" color="#333" size="1x" />
                                        </span>
                                    )}
                                    {this.state.found_student && (
                                        <span onClick={this.clearRegData.bind(this, 'student')}>
                                            <FontAwesomeIcon className="icon" icon="times" color="#333" size="1x" />
                                        </span>
                                    )}
                                    {this.state.student_regcode_error && <label className="error text-danger">{this.state.student_regcode_error}</label>}
                                </div>
                            </div>
                        </div>
                        <hr />
                        <br />
                        <form>
                            <div className="row clearfix">
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('student:student.add.nameLabel')} *</label>
                                    <Input name="name" onChange={this._handleChange} placeholder={t('student:student.add.namePlaceholder')} type="text" readOnly={this.state.found_student && 'true'} value={this.state.name} />
                                    {this.state.errors.name && <label className="error text-danger">{this.state.errors.name}</label>}
                                </div>
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('student:student.add.emailLabel')}</label>
                                    <Input name="email" onChange={this._handleChange} placeholder={t('student:student.add.emailPlaceholder')} type="text" readOnly={this.state.found_student && 'true'} value={this.state.email} />
                                    {this.state.errors.email && <label className="error text-danger">{this.state.errors.email}</label>}
                                </div>
                            </div>
                            <div className="row clearfix">
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('student:student.add.dobLabel')} *</label>
                                    <DatePicker dateFormat="yyyy-MM-dd" className="form-control" selected={this.state.dob} onChange={this.setDate} readOnly={this.state.found_student && 'true'} placeholderText={t('student:student.add.dobplaceholder')} maxDate={moment().toDate()} />
                                    {this.props.school != null && this.props.school.school != null && this.props.school.school.date_format == 'BS' && <label className="date-bs">{this.state.dob != null ? (convertADtoBS(this.state.dob) != null ? convertADtoBS(this.state.dob) + ' BS' : 'Invalid Date Range') : ''}</label>}
                                    {this.state.errors.dob && <label className="error text-danger">{this.state.errors.dob}</label>}
                                </div>
                                <div className="col-sm-6 float-left form-group">
                                    <label className="form-title">{t('student:student.add.joinDateLabel')} *</label>
                                    <DatePicker dateFormat="yyyy-MM-dd" className="form-control" selected={this.state.joining_date} onChange={this.setJoinDate} placeholderText={t('student:student.add.joinDatePlaceholder')} />
                                    {this.props.school != null && this.props.school.school != null && this.props.school.school.date_format == 'BS' && <label className="date-bs">{this.state.joining_date != null ? (convertADtoBS(this.state.joining_date) != null ? convertADtoBS(this.state.joining_date) + ' BS' : 'Invalid Date Range') : ''}</label>}
                                    {this.state.errors.joining_date && <label className="error text-danger">{this.state.errors.joining_date}</label>}
                                </div>
                            </div>
                            <div className="row clearfix">
                                <div className="col-sm-6 float-left form-group main-select">
                                    <label className="form-title">{t('student:student.add.studentCategoryLabel')}</label>
                                    <Select name="student_category" options={this.state.student_category} placeholder={t('student:student.add.studentCategoryPlaceholder')} searchable={true} selected={this.state.selectedStudentCategory} onChange={this.setStudentCategory} />
                                </div>
                                {this.state.roll_no_required == true && (
                                    <div className="col-sm-6 float-left form-group main-select">
                                        <label className="form-title">{t('student:student.rollNo')}</label>
                                        <Input name="roll_no" onChange={this._handleChange} placeholder={t('student:student.rollNo')} type="number" step="1" value={this.state.roll_no} />
                                        {this.state.roll_number_validation_msg && <label className="error text-danger">{this.state.roll_number_validation_msg}</label>}
                                    </div>
                                )}
                            </div>

                            <div className="row clearfix">
                                <div className="col-sm-3 float-left form-group">
                                    <Button onClick={this._onSave} type="submit" text={t('common:savebtn')} main={true} />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        )
    }
}

const StudentAdd = withTranslation()(connect(mapStateToProps)(StudentAddComponent))

export { StudentAdd }
